import React, { useEffect, useRef, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Footer from '../Footer';
import { toast } from 'react-toastify';

import axios from 'axios';
import config from '../../function/config';
import Usernav from '../UserHome/Usernav';
import AdminNav from '../Admin/AdminHome/AdminNav';
import HomeNav from '../Navbars/HomeNav';
import { Phone } from 'lucide-react';
import NewAdminNav from '../Admin/AdminHome/NewAdminNav';
import NewHomeNav from '../Navbars/NewHomeNav';
import NewFooter from '../NewFooter';

export default function RegisterPurchaseQuery() {

  
const [isScrolled, setIsScrolled] = useState(false);
 useEffect(() => {
        const handleScroll = () => {
          setIsScrolled(window.scrollY > 50); // Adjust the value to when you want the effect
        };
    
        window.addEventListener('scroll', handleScroll);
    
        return () => {
          window.removeEventListener('scroll', handleScroll);
        };
      }, []);
      
  // Scroll to the top
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
      
        
        const navigate = useNavigate()
        
          

          const [formType, setFormType] = useState("sale"); // Default to "sale"
          const [loading,setLoading] = useState(false)
          const[Title,setTitle] = useState('')
          const[ShipType,setShipType] = useState('')
          const[ShortDescription,setShortDescription] = useState('')
          const[Flag,setFlag] = useState('')
          const[YearBuilt,setYearBuilt] = useState('')
          const[Capacity,setCapacity] = useState('')
          const[LOA,setLOA] = useState('')
          const[Classification,setClassification] = useState('')
          const[GRTNRT,setGRTNRT] = useState('')
          const[Teu,setTeu] = useState('')
          const[Price,setPrice] = useState('')
          const[MainEngine,setMainEngine] = useState('')
          const[DWT,setDWT] = useState('')

          const[Email,setEmail] = useState('')
          const[MobileNO,setMobileNO] = useState('')
          const[BriefDescription,setBriefDescription] = useState('')
          const [images, setImages] = useState([]);
          

          

          const [count,setCount] = useState(0)


         const [selectedImages, setSelectedImages] = useState([]); // Array of { file, preview }
         
         const handleImageChange = (e) => {
           const files = Array.from(e.target.files);
           const newImages = files.slice(0, 3 - images.length).map((file) => ({
             file,
             preview: URL.createObjectURL(file),
           }));
         
           setImages((prevImages) => [...prevImages, ...newImages]);
         };
         
         const removeImage = (index) => {
           const updated = [...images];
           updated.splice(index, 1);
           setImages(updated);
         };
          
          // register ship
          
        

      const [user,setUser] = useState(null)
        const token = localStorage.getItem('token')
        useEffect(() => {
                if (!token) {
                  navigate('/login'); // login page
                }
              }, [token, navigate]);

    
    useEffect(() => {
        async function fetchdata() {
          try {
            const res2 = await axios.get(
              `${config.base_url}/api/HappyMarineShipping/viewusers`,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                  Authorization: `Token ${token}`,
                },
              }
            );
            console.log("API response:", res2.data);
            if (res2.data.status === 200) {
              console.log("User:",res2);
              setUser(res2.data.data);
            } else {
              console.log(res2);
            }
          } catch (error) {
            console.log(error);
          }
        }
        fetchdata();
      }, [ token]);

     

        const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  const [CompanyAddress,setCompanyAddress] = useState('');
    const [Company,setCompany] = useState('');
    const [name,setName] = useState('');
    const [Lychan,setLychan] = useState('');
    const [TypeOfCargo,setTypeOfCargo] = useState('')
    const [Tonnage,setTonnage] = useState('')
    const [LoadingPort,setLoadingPort] = useState('')
    const [DischargePort,setDischargePort] = useState('')
    const [ChartererAcc,setChartererAcc] = useState('')
    const [Commission,setCommission] = useState('')
    const userId = localStorage.getItem("userId");
    const [Budget,setBudget] = useState('')
    

    const handleSubmitPurchase = async (e, id) => {
        e.preventDefault();
        setLoading(true);
    
        const formData = new FormData();
    
        // Append text fields
        
        formData.append("user", userId);
         formData.append("ship_type", ShipType);
            formData.append("year_built", YearBuilt);
            formData.append("capacity", Capacity);
            formData.append("classification", Classification);
            formData.append("budget", Budget);
            formData.append("name", name);
            formData.append("email", Email);
            formData.append("phone", Phone);
            formData.append("brief_description", BriefDescription);
            
    
        try {
          const response = await axios.post(
            `${config.base_url}/api/HappyMarineShipping/add_purchase_query`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Token ${token}`,
              },
            }
          );
          console.log("API Response:", response.data);
          if (response.data.status === 200) {
            navigate("/regShip");
            setLoading(false);
            toast.success("Registered Successfully!", {
              autoClose: 1500,
              position: "top-right",
            });
    
            // Reset form state
            setCount(id);
           
          } else {
            setLoading(false);
            toast.error("Fill the  Fields", {
              autoClose: 1500,
              position: "top-right",
            });
          }
        } catch (err) {
          setLoading(false);
          console.error("Error:", err);
          toast.error("Error", {
            autoClose: 2000,
            position: "top-right",
          });
        }
      };
        
  return (
    <div className='bg-[#9ccee2]'>

        {user ? (user.is_superuser ? <NewAdminNav /> :  <Usernav />) : <NewHomeNav/>}

        <section className='mt-14 mb-10'> 
        <div className=" px-[30px] xm:px-[10px] w-[100%] lg:w-[90%] m-auto  rounded ">
            
      {/* Links for selecting form type */}
      <div className="flex justify-center gap-8 lg:flex-wrap lg:gap-5 items-center">
        
        <button
          
           className='text-[#2e5775] text-2xl mb-3 font-bold'
        >
          Ship Purchase Inquiry
        </button>
        
        
      </div>

    <Link to={'/regShip'} className='px-3  text-[#2e5775]'><i className='fa-solid fa-beat fa-arrow-left '></i> Back</Link>
      

      {/* Conditional Form Rendering */}
      


      <form className="bg-white mt-2 rounded w-full">
  <div className="p-5">
    <h1 className="text-black font-bold text-xl">Ship Purchase Inquiry </h1>
  </div>
  <hr className="text-gray-100 w-full" />

  {/* Vessel Type & Reference Id */}
  <div className="p-5 flex flex-col gap-5">
    <div className="flex items-center gap-4">
      <label htmlFor="ShipType" className="font-semibold w-[200px]">
        Ship Type
      </label>
      <select
        value={ShipType}
        onChange={(e) => setShipType(e.target.value)}
        className="flex-1 rounded border border-gray-400 p-2 text-[#d1a460]"
        id="ShipType"
      >
        <option hidden value="">
          -Select-
        </option>
        <option disabled value="">
          Categories
        </option>
        <option value="Barge">Barge</option>
        <option value="Bulk">Bulk</option>
        <option value="Cargo">Cargo</option>
        <option value="Container">Container</option>
        <option value="Fishing">Fishing</option>
        <option value="Multipurpose">Multipurpose</option>
        <option value="Passenger/Ferry">Passenger/Ferry</option>
        <option value="Reefer">Reefer</option>
        <option value="RoRo">RoRo</option>
        <option value="Tanker">Tanker</option>
        <option value="Dredger">Dredger</option>
        <option value="Floating Crane">Floating Crane</option>
        <option value="Floating Dock">Floating Dock</option>
        <option value="Landing Craft">Landing Craft</option>
        <option value="Yacht">Yacht</option>
        <option value="Tug Boat">Tug Boat</option>
        <option value="Supply Boat">Supply Boat</option>
        <option value="Crew Boat">Crew Boat</option>
        <option value="Other">Other</option>
      </select>
    </div>

    
  </div>

  {/* Open Area & DWT */}
  <div className="p-5 flex flex-col gap-5">


    <div className="flex items-center gap-4">
      <label htmlFor="Capacity" className="font-semibold w-[200px]">
        Capacity
      </label>
      <input
      required
        value={Capacity}
        placeholder="Enter the Capacity"
        onChange={(e) => setCapacity(e.target.value)}
        className="flex-1 rounded border border-gray-400 p-2 text-gray-500"
        id="Capacity"
      />
    </div>
  </div>

  {/* TC/VC & Year Built */}
  <div className="p-5 flex flex-col gap-5">

    <div className="flex items-center gap-4">
      <label htmlFor="YearBuilt" className="font-semibold w-[200px]">
        Year Built
      </label>
      <input
      required
        value={YearBuilt}
        placeholder="Enter Built Year"
        onChange={(e) => setYearBuilt(e.target.value)}
        className="flex-1 rounded border border-gray-400 p-2 text-gray-500"
        id="YearBuilt"
      />
    </div>
  </div>

  {/* Lychan */}
  <div className="p-5 flex flex-col gap-5">
    <div className="flex items-center gap-4">
      <label htmlFor="Budget" className="font-semibold w-[200px]">
        Budget
      </label>
      <input
      required
        value={Budget}
        placeholder="Enter Budget"
        onChange={(e) => setBudget(e.target.value)}
        className="flex-1 rounded border border-gray-400 p-2 text-gray-500"
        id="Budget"
      />
    </div>
  </div>

  {/* Ship Owner Name & Company */}
  <div className="p-5 flex flex-col gap-5">
    <div className="flex items-center gap-4">
      <label htmlFor="Classification" className="font-semibold w-[200px]">
        classification
      </label>
      <input
      required
        value={Classification}
        placeholder="Enter  Classification"
        onChange={(e) => setClassification(e.target.value)}
        className="flex-1 rounded border border-gray-400 p-2 text-gray-500"
        id="Classification"
      />
    </div>

   

   
  </div>

  <div className="p-5 flex flex-col gap-5">
    <div className="flex items-center gap-4">
      <label htmlFor="Name" className="font-semibold w-[200px]">
         Name
      </label>
      <input
        value={name}
        placeholder="Enter Your Name"
        onChange={(e) => setName(e.target.value)}
        className="flex-1 rounded border border-gray-400 p-2 text-gray-500"
        id="Name"
      />
    </div>



    
  </div>

  {/* Email & Mobile */}
  <div className="p-5 flex flex-col gap-5">
    <div className="flex items-center gap-4">
      <label htmlFor="Email" className="font-semibold w-[200px]">
        Email
      </label>
      <input
        value={Email}
        placeholder="Enter your Email"
        onChange={(e) => setEmail(e.target.value)}
        className="flex-1 rounded border border-gray-400 p-2 text-gray-500"
        id="Email"
      />
    </div>

    <div className="flex items-center gap-4">
      <label htmlFor="MobileNO" className="font-semibold w-[200px]">
        Mobile No
      </label>
      <input
        value={MobileNO}
        placeholder="Enter your Mobile No"
        onChange={(e) => setMobileNO(e.target.value)}
        className="flex-1 rounded border border-gray-400 p-2 text-gray-500"
        id="MobileNO"
      />
    </div>
  </div>

  {/* Additional Info */}
  <div className="p-5 flex items-start gap-4">
    <label htmlFor="BriefDescription" className="font-semibold w-[200px]">
      Additional Information
    </label>
    <textarea
      placeholder="More info..."
      value={BriefDescription}
      onChange={(e) => setBriefDescription(e.target.value)}
      rows={5}
      className="flex-1 rounded border border-gray-400 p-2 text-gray-500"
      id="BriefDescription"
    ></textarea>
  </div>


  {/* Submit */}
  <hr className="text-gray-500 w-full" />
  <div className="p-4">
    <button
      type="submit"
      onClick={(e) => handleSubmitPurchase(e)}
      className="bg-green-600 hover:bg-green-500 text-white px-5 py-2 rounded w-full"
    >
      Submit
    </button>
  </div>
</form>


    </div>
        
        
        </section>
    

    
    {/* Go to Top Button */}
    {isScrolled && (
  <div
    className="fixed bottom-16 right-8 z-50 " // Ensure it's in the right position with high z-index
  >
    <div
      className="back-to-top px-4 hover:bg-[#615d91]"
      onClick={scrollToTop}
    >
      <i className="fa-solid fa-arrow-up text-2xl"></i>
    </div>
  </div>
)}
     
    <NewFooter/>
      
    </div>
  )
}
